<template>
    <hts-loading
        :loading="loading"
        class="pb-5">
        <hts-ui-tabs
            v-model="tab"
            :tabs="tabs" />
        <div v-show="tab === 'time'">
            <div class="bg-gray-100 mb-2 border rounded-md overflow-hidden">
                <div class="my-2 ml-2">
                    <span
                        class="px-2 py-1 rounded-md"
                        :class="getTravelStyle(list[0])">
                        Khởi hành:&nbsp;{{ $location.getLocation(journey.startAtLocationId)?.locationName }}
                    </span>
                </div>

                <div class="flex items-center justify-between gap-2 px-2 mb-2">
                    <hts-form-date
                        v-model="startAtActual"
                        placeholder="Thời gian khởi hành"
                        type="datetime"
                        time-format="HH:mm"
                        :disabled="checkIndexDisabled(list[0]) || cDisabled"
                        confirm
                        class="w-72"
                        @change="handleChangeStartAtActual" />
                </div>
            </div>

            <template
                v-for="(travel, index) in list"
                :key="index">
                <div class="bg-gray-100 mb-2 border rounded-md overflow-hidden">
                    <div class="my-2 ml-2">
                        <span
                            class="px-2 py-1 rounded-md"
                            :class="getTravelStyle(travel)">
                            Vị trí {{ travel.index }}:&nbsp;{{ travel.stage?.nodeName }}
                        </span>
                    </div>
                    <div class="flex items-center justify-between gap-2 px-2">
                        <hts-form-date
                            v-model="travel.stage.ata"
                            placeholder="Thời gian vào điểm"
                            type="datetime"
                            time-format="HH:mm"
                            :disabled="checkIndexDisabled(travel) || cDisabled"
                            confirm
                            class="w-72"
                            @change="handleChangeActualTime(travel.stage, 'ata', $event)" />
                        <hts-form-date
                            v-model="travel.stage.atd"
                            placeholder="Thời gian ra điểm"
                            type="datetime"
                            time-format="HH:mm"
                            :disabled="checkIndexDisabled(travel) || cDisabled"
                            confirm
                            class="w-72"
                            @change="handleChangeActualTime(travel.stage, 'atd', $event)" />
                    </div>
                    <div class="grid grid-cols-7 gap-2 p-2">
                        <div>
                            <!--
                              <span class="text-sm text-white bg-blue-500 px-2 py-1 rounded-md">
                              Vị trí {{ travel.index }}
                              </span>
                            -->
                        </div>
                        <div>
                            <span>
                                Tác vụ
                            </span>
                        </div>
                        <div>
                            <span>
                                Chịu trách nhiệm bởi
                            </span>
                        </div>
                        <div>
                            <span>
                                Bắt đầu
                            </span>
                        </div>
                        <div>
                            <span>
                                Kết thúc
                            </span>
                        </div>
                        <div>
                            <span>
                                Tác vụ trước
                            </span>
                        </div>
                        <div>
                            <span>
                                Tác vụ sau
                            </span>
                        </div>
                    </div>
                    <template
                        v-for="(tmp, tmpIndex) in travel.tasks"
                        :key="tmpIndex">
                        <div
                            class="grid grid-cols-7 gap-2 p-2"
                            :class="{ 'bg-white': !(index % 2 === 1), 'bg-gray-100': index % 2 === 1 }">
                            <div class="col-span-2">
                                {{ tmp.taskName }}
                            </div>
                            <div class="">
                                {{ getResponsible(tmp) }}
                            </div>
                            <div class="flex items-center">
                                <hts-form-date
                                    v-model="tmp.ata"
                                    type="datetime"
                                    time-format="HH:mm"
                                    confirm
                                    @change="handleChangeActualTime(tmp, 'ata', $event)" />
                            </div>
                            <div class="flex items-center">
                                <hts-form-date
                                    v-model="tmp.atd"
                                    type="datetime"
                                    time-format="HH:mm"
                                    confirm
                                    @change="handleChangeActualTime(tmp, 'atd', $event)" />
                            </div>
                            <div>
                                <sub-tasks :tasks="tmp.subTasks?.pre" />
                            </div>
                            <div>
                                <sub-tasks :tasks="tmp.subTasks?.post" />
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <div class="bg-gray-100 mb-2 border rounded-md overflow-hidden">
                <div class="my-2 ml-2">
                    <span
                        class="px-2 py-1 rounded-md"
                        :class="getTravelStyle(list[list.length - 1])">
                        Kết thúc:&nbsp;{{ $location.getLocation(journey.stopAtLocationId)?.locationName }}
                    </span>
                </div>
                <div class="flex items-center justify-between gap-2 px-2 mb-2">
                    <hts-form-date
                        v-model="stopAtActual"
                        placeholder="Thời gian kết thúc"
                        type="datetime"
                        time-format="HH:mm"
                        :disabled="checkIndexDisabled(list[list.length - 1]) || cDisabled"
                        confirm
                        class="w-72"
                        @change="handleChangeStopAtActual" />
                </div>
            </div>
        </div>
        <div v-show="tab === 'jobs'">
            <div class="bg-gray-100 mb-2 border rounded-md overflow-hidden">
                <div class="grid grid-cols-5 gap-2 p-2">
                    <div class="col-span-2">
                        <span>
                            Công việc
                        </span>
                    </div>
                    <div>
                        <span>
                            Tác vụ trước
                        </span>
                    </div>
                    <div>
                        <span>
                            Sau tác vụ
                        </span>
                    </div>
                    <div>
                        <span>
                            Thời gian hoàn thành
                        </span>
                    </div>
                </div>
                <template
                    v-for="(job, jobIndex) in jobList"
                    :key="jobIndex">
                    <div
                        class="grid grid-cols-5 gap-2 p-2"
                        :class="{ 'bg-white': !(jobIndex % 2 === 1), 'bg-gray-100': jobIndex % 2 === 1 }">
                        <div class="col-span-2">
                            {{ job.taskName }}
                        </div>
                        <div class="flex items-center">
                            <template v-if="job.condition === 'pre'">
                                {{ job.taskConditionName }}
                            </template>
                        </div>
                        <div class="flex items-center">
                            <template v-if="job.condition === 'post'">
                                {{ job.taskConditionName }}
                            </template>
                        </div>
                        <div class="flex items-center">
                            <hts-form-date
                                v-model="job.atd"
                                type="datetime"
                                time-format="HH:mm"
                                confirm
                                @change="handleChangeJobCompleteTime(job, $event)" />
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </hts-loading>
</template>
<script lang="ts" setup>
import SubTasks from './sub-tasks.vue'
const tab = ref('time')
const tabs = ref([
  { key: 'time', label: $t('labels.journeyTime') },
  { key: 'jobs', label: $t('labels.jobs'), icon: 'hi-view-list-icon' }
])
const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const emits = defineEmits(['change'])
const { $formatters } = useNuxtApp()
const { journey } = toRefs(props)
const loading = ref(true)
const travelDetails = computed<any>(() => journey.value.travelDetails || {})
const cDisabled = computed(() => false)
const stageIndexBegin = computed<any>(() => journey.value.stageIndexBegin || 0)
const stageIndexEnd = computed<any>(() => journey.value.stageIndexEnd || 999)
const { $location } = useNuxtApp()

const list = ref<any[]>([])
const jobList = ref<any[]>([])
const startAtActual = ref<null | string>(null)
const stopAtActual = ref<null | string>(null)

onMounted(() => {
  loading.value = true
  setList()
  setActualTime()
  jobList.value = journey.value.condition || []
  nextTick(() => {
    loading.value = false
  })
})
const setList = () => {
  list.value = JSON.parse(JSON.stringify(travelDetails.value))
    .filter((t: any) => t.type === 'stage')
    .map((t: any) => {
      Object.assign(t, {
        ata: $formatters.datetime(t.ata, 'YYYY-MM-DD HH:mm'),
        atd: $formatters.datetime(t.atd, 'YYYY-MM-DD HH:mm')
      })
      return {
        stage: t,
        index: t.index + 1,
        label: t.nodeName,
        tasks: getTasks(t.stageIndex)
      }
    })
}
const setActualTime = () => {
  startAtActual.value = journey.value?.startAtActual ? $formatters.datetime(journey.value?.startAtActual, 'YYYY-MM-DD HH:mm') : null
  stopAtActual.value = journey.value?.stopAtActual ? $formatters.datetime(journey.value?.stopAtActual, 'YYYY-MM-DD HH:mm') : null
}
const getTasks = (stageIndex: number) => {
  return JSON.parse(JSON.stringify(travelDetails.value))
    .filter((t: any) => t.type === 'task' && t.stageIndex === stageIndex)
    .map((t: any) => {
      Object.assign(t, {
        ata: $formatters.datetime(t.ata, 'YYYY-MM-DD HH:mm'),
        atd: $formatters.datetime(t.atd, 'YYYY-MM-DD HH:mm')
      })
      return t
    })
}
const getResponsible = (task: any) => {
  return task.responsibleForImplementation === 'CUSTOMER' ? 'Khách hàng' : 'Tài xế'
}
const handleChangeActualTime = (data: any, attr: string, value: any) => {
  const { _id } = data
  $api($urlClient.monitoring.journey.setActualTime, { uriParams: { ID: journey.value._id }, body: { _id, attr, value } })
    .then(() => {
      emits('change')
    })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        process.client && $toast().success($t('labels.updateSuccess'))
      }
    })
}
const handleChangeJobCompleteTime = (data: any, value: any) => {
  const { index } = data
  $api($urlClient.monitoring.journey.setJobCompleteTime, { uriParams: { ID: journey.value._id }, body: { index, value } })
    .then(() => {
      emits('change')
    })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        process.client && $toast().success($t('labels.updateSuccess'))
      }
    })
}

const handleChangeStartAtActual = (value: string) => {
  $api($urlClient.monitoring.journey.setActualTime, { uriParams: { ID: journey.value._id }, body: { attr: 'startAtActual', value } })
    .then(() => {
      emits('change')
    })
    .then((data: any) => {
      const resData: any = data?.data?.value

      if (resData?.success) {
        process.client && $toast().success($t('labels.updateSuccess'))
      }
    })
}

const handleChangeStopAtActual = (value: string) => {
  $api($urlClient.monitoring.journey.setActualTime, { uriParams: { ID: journey.value._id }, body: { attr: 'stopAtActual', value } })
    .then(() => {
      emits('change')
    })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        process.client && $toast().success($t('labels.updateSuccess'))
      }
    })
}

const getTravelStyle = (travel: any) => {
  const disabled = checkIndexDisabled(travel)
  if (disabled) {
    return ['bg-gray-300', 'text-gray-700']
  }
  return ['bg-blue-500', 'text-white']
}
const checkIndexDisabled = (travel: any) => {
  let tmpIndex = travel?.index
  if (Number.isNaN(tmpIndex)) {
    return true
  }
  tmpIndex = tmpIndex - 1
  return tmpIndex < stageIndexBegin.value || tmpIndex > stageIndexEnd.value
}
</script>
